import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-next2',
  templateUrl: './button-next2.component.html',
  styleUrls: ['./button-next2.component.less']
})
export class ButtonNext2Component implements OnInit {
  @Input() disabled: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
